const matches = [
    /Proxy creation for class ".+" on agent ".+" and domain ".+" timed out \(> \d+ ms\)/,
    /Connection trial timed out \(> \d+ ms\)/,
    /Function call ".+::.+\(\)" timed out \(> \d+ ms\)/,
]

export const isTimeoutError = (error: unknown): boolean => error instanceof Error && matches.some((m) => m.test(error.message))
